export default {
      id: "filter-usage",
      viewBox: "0 0 32 32",
      url: __webpack_public_path__ + "sprite.svg#filter",
      toString: function () {
        return this.url;
      }
    }